module.exports = __webpack_public_path__ + "static/media/baetz.aee91db5.jpg";